import request from "@/utils/request.js";
// 查询用户权限菜单
export const GetUserMenuList = (params) => {
  return request({
    url: "/getRouters",
    method: "get",
    params,
  });
};
// 查询全部菜单
export const GetAllMenuList = (params) => {
  return request({
    url: "/system/menu/list",
    method: "get",
    params,
  });
};
// 查询目录
export const GetMenuSelect = (params) => {
  return request({
    url: "/system/menu/treeselect",
    method: "get",
    params,
  });
};
// 菜单添加
export const addMenu = (data) => {
  return request({
    url: "/system/menu",
    method: "post",
    data,
  });
};
// 菜单编辑
export const updateMenu = (data) => {
  return request({
    url: "/system/menu",
    method: "put",
    data,
  });
};
// 菜单删除
export const deleteMenu = (id) => {
  return request({
    url: `/system/menu/${id}`,
    method: "delete",
  });
};
// 查询详细
export const GetMenuInfo = (id) => {
  return request({
    url: `/system/menu/${id}`,
    method: "get",
  });
};
